class ViewController {
  /* @ngInject */
  constructor(
    $stateParams, $sce, $window, $http, $timeout, $state, Session, urls, moment,
    CaseCheckService, CifShareService, SUB_CASE_STATES, SubcaseStateChangeService,
    AllocateSubcaseService, ENABLE_TA_DATE_CLIENT_IDS, CASE_JOINING_STATUSES
  ) {
    this.$stateParams = $stateParams;
    this.$sce = $sce;
    this.$window = $window;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$state = $state;
    this.Session = Session;
    this.moment = moment;
    this.urls = urls;
    this.CaseCheckService = CaseCheckService;
    this.CifShareService = CifShareService;
    this.SubcaseStateChangeService = SubcaseStateChangeService;
    this.AllocateSubcaseService = AllocateSubcaseService;
    this.SUB_CASE_STATES = SUB_CASE_STATES;
    this.ENABLE_TA_DATE_CLIENT_IDS = ENABLE_TA_DATE_CLIENT_IDS;
    this.CASE_JOINING_STATUSES = CASE_JOINING_STATUSES;
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.isBetaUser = (this.Session.read('debug') || {}).userType === 'beta';
    this.isVendor = this.user.client.type === 'VENDOR';
    this.isCustomer = this.user.client.type === 'CUSTOMER';
    this.viewSrc = 'CIF';
    this.isSpecialClient = this.ENABLE_TA_DATE_CLIENT_IDS.includes(this.case.Creator.Client.id);
    this.stopTatSwitch = this.case.disable_tat_cron === 1;
    this.caseId = this.$stateParams.id;
    this.activeTab = +this.$stateParams.activeTab;
    this.templateId = this.$stateParams.templateId;
    this.subCaseState = this.$stateParams.subCaseState;
    this.isTaDateOpen = false;
    this.isDojDateOpen = false;
    this.datepickerOptionsDOJ = {
      dateDisabled: ({ date, mode }) =>
        (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6)),
    };
    this.attachments = [];
    this.identityDocuments = [];
    this.educationDocuments = [];
    this.employmentDocuments = [];
    this.authorizationDocuments = [];
    this.miscDocuments = [];
    this.subCases = [];
    this.checks = [{
      key: 'education',
      text: 'Education Check',
    },
    {
      key: 'employmentCheck',
      text: 'Employment Check',
    },
    {
      key: 'uanCheck',
      text: 'UAN Check',
    },
    {
      key: 'cvValidationCheck',
      text: 'CV Validation Check',
    },
    {
      key: 'gapInEmploymentHistoryCheck',
      text: 'Gap in Employment History Check',
    },
    {
      key: 'addressCheck',
      text: 'Address Check - Physical',
    },
    {
      key: 'digitalAddressCheck',
      text: 'Address Check - Digital',
    },
    {
      key: 'criminalPoliceCheck',
      text: 'Criminal Police Check',
    },
    {
      key: 'employmentReferenceCheck',
      text: 'Reference Check',
    },
    {
      key: 'globalDatabaseCheck',
      text: 'Global Database Check',
    },
    {
      key: 'indianDatabaseCheck',
      text: 'Indian Database Check',
    },
    {
      key: 'criminalCourtRecordCheck',
      text: 'Criminal Court Record Check',
    },
    {
      key: 'eCourtRecordCheck',
      text: 'E-Court Record Check',
    },
    {
      key: 'openWebScanCheck',
      text: 'Open Web Scan Check',
    },
    {
      key: 'identity',
      text: 'Identity',
    },
    {
      key: 'creditScoreCheck',
      text: 'Credit Score Check',
    }];

    this.totalFileCount = 0;

    this.cifSrc = this.trustSrc(`${this.urls.VERIFY_APP
    }/api/case/${this.$stateParams.id
    }/response/cif?access_token=${this.Session.accessToken}`);

    this.caseCheck = this.case.CaseChecks.reduce((acc, check) =>
      Object.assign(acc, { [check.check]: check })
    , {});

    if (this.isVendor) this.getSubCases();

    if (this.case.CaseResponse) {
      this.attachments = this.case.CaseResponse.CaseResponseAttachments
        .filter(a => !['CifUnsigned'].includes(a.type));

      this.attachments.forEach(v => {
        if (['Pan', 'Passport', 'Aadhaar', 'DrivingLicense'].includes(v.type)) {
          this.identityDocuments.push(Object.assign(v, {
            filename: v.path.split('/').pop(),
          }));

          this.totalFileCount += 1;
        } else if (v.type === 'Degree') {
          this.educationDocuments.push(Object.assign(v, {
            filename: v.path.split('/').pop(),
          }));

          this.totalFileCount += 1;
        } else if (v.type === 'Employment') {
          this.employmentDocuments.push(Object.assign(v, {
            filename: v.path.split('/').pop(),
          }));

          this.totalFileCount += 1;
        } else if (['CifSigned'].includes(v.type)) {
          this.authorizationDocuments.push(Object.assign(v, {
            filename: v.path.split('/').pop(),
          }));

          this.totalFileCount += 1;
        } else if (['Miscellaneous', 'Resume'].includes(v.type)) {
          this.miscDocuments.push(Object.assign(v, {
            filename: v.path.split('/').pop(),
          }));

          this.totalFileCount += 1;
        }
      });
    }
  }

  getCifFile() {
    this.$http.get(`${this.URLS.CRUX_API}/candidates/${this.$stateParams.candidateId}/resume`)
    .then(({ data: resume }) => {
      const c = Object.assign(this.data, resume);
      this.data = c;
    }).catch(() => {
      const c = Object.assign(this.data, {
        resumeLink: `${this.URLS.QUARC_API}/api/404`,
      });
      this.data = c;
    });
  }

  getSubCases() {
    this.$http
      .get(`/case/${this.caseId}/subCase`, {
        params: {
          templateId: this.templateId,
          subCaseState: this.subCaseState,
        },
      })
      .then(({ data: subCases }) => {
        this.subCases = subCases;
      });
  }

  resetSubCaseTab() {
    this.templateId = null;
    this.subCaseState = null;

    this.$state.go('.', {
      templateId: null,
      subCaseState: null,
    }, { notify: false });

    this.getSubCases();
  }

  checkClass(type) {
    if (!this.caseCheck[type]) {
      return 'fa-check text-muted';
    }

    switch (this.caseCheck[type].status) {
      case 'In-Process': return 'fa-check-circle text-info';
      case 'Pending': return 'fa-check-circle text-warning';
      case 'Positive': return 'fa-check-circle text-success';
      case 'Negative': return 'fa-check-circle text-danger';
      case 'Discrepant': return 'fa-check-circle text-warning';
      default: return 'fa-check-circle text-muted';
    }
  }

  trustSrc(src) {
    if (!src) return '';

    return this.$sce.trustAsResourceUrl(`${this.urls.PDF_JS}?file=${
      encodeURIComponent(src)
      }&zoom=page-width`);
  }

  downloadAll() {
    this.$window.open(
      `${this.urls.API_SERVER}/api/caseResponse/${
        this.case.CaseResponse.id}/attachment?access_token=${this.Session.accessToken}`,
      '_blank'
    );
  }

  downloadLatestReport() {
    this.$window.open(
      `${this.urls.API_SERVER}/api/case/casestate/${
        this.case.reportCaseState.id}/attachment?access_token=${this.Session.accessToken}`,
      '_blank'
    );
  }

  getSubCase(subCase) {
    this.showSpinner = true;
    this.subCase = subCase;

    this.$http.get(`/subCase/${subCase.id}`)
      .then(({ data }) => {
        Object.assign(this.subCase, data);
        this.viewSrc = 'SUB_CASE';

        if (this.case.CaseResponse) {
          const urlRegEx = /onclick='(\d+)'/g;
          this.subCase.html = this.subCase.html
            .replace(urlRegEx, `ng-click="$ctrl.download('$1', ${this.case.CaseResponse.id})"`);
        }

        this.showSpinner = false;
      })
      .catch(() => (this.showSpinner = false));
  }

  download(fileId, caseResponseId) {
    if (fileId && caseResponseId) {
      this.$window.open(
        `${this.urls.API_SERVER}/api/caseResponse/${caseResponseId}/attachment/${
          fileId}?access_token=${this.Session.accessToken}`,
        '_blank'
      );
    }
  }

  isCasesSelected() {
    return this.subCases.some(c => c.selected);
  }

  generateReport() {
    if (!this.isCasesSelected()) {
      this.generateReportErr = true;
      this.$timeout(() => {
        this.generateReportErr = false;
      }, 5000);

      return false;
    }

    const selectedIds = this.subCases.reduce((acc, c) => {
      if (c.selected) acc.push(c.id);

      return acc;
    }, []).join();

    return this.$window.open(
      `${this.urls.API_SERVER}/api/case/${this.caseId}/generateReport?selectedIds=${
        selectedIds}&access_token=${
        this.Session.accessToken}`,
      '_blank'
    );
  }

  toggleSelect() {
    this.subCases.map(c => Object.assign(c, {
      selected: c.SubCaseResponse && this.selectAll && c.CurrentSubCaseState.state === 'Closed',
    }));
  }

  createSubCase() {
    if (this.case.CaseResponse) {
      this.$state.go('main.cases.newSubCase', { id: this.caseId });
    } else {
      this.AllocateSubcaseService.open(this.caseId, {
        customSubCase: true,
      });
    }
  }

  downloadCustomAttachment(attach) {
    this.$window.open(
      `${this.urls.API_SERVER}/api/subCase/${this.subCase.id}/custom/attachment?filename=${
        attach}&access_token=${this.Session.accessToken}`,
      '_blank'
    );
  }

  editCommercials(subCase) {
    this.$http.put(`/subCase/${subCase.id}/addonCommercial`, {
      addon_commercial: subCase.addon_commercial,
    })
      .then(() => {
        this.textMsg = 'Updated Successfully';

        this.$timeout(() => {
          this.textMsg = '';
        }, 5000);
      });
  }

  calculateTAT() {
    this.$http
      .post(`/case/${this.caseId}/tat/calculate`, {
        dates: [
          this.case.overrided_final_init_date || new Date(),
          this.case.overrided_completion_date || new Date(),
        ],
      })
      .then(({ data }) => {
        this.case.overrided_tat = data.tat;
      });
  }

  overideTAT() {
    this.$http.post(`/case/${this.caseId}/tat/override`, {
      overridedTat: this.case.overrided_tat || null,
      overridedInitDate: this.case.overrided_init_date,
      overridedFinalInitDate: this.case.overrided_final_init_date,
      overridedCompletionDate: this.case.overrided_completion_date,
      disableTatCron: this.stopTatSwitch ? 1 : 0,
    })
      .then(() => {
        this.overideTatTextMsg = 'Updated Successfully';

        this.$timeout(() => {
          this.overideTatTextMsg = '';
          this.overideTatIsOpen = false;
        }, 5000);
      });
  }

  editInternalDetails() {
    this.$http.post(`/case/${this.caseId}/internal-details`, {
      taDate: this.case.ta_date || null,
      dojDate: this.case.doj_date || null,
      joiningStatus: this.case.joining_status || null,
      customFields: this.case.custom_fields || null,
    })
      .then(() => {
        this.editInternalDetailsTxtMsg = 'Updated Successfully';

        this.$timeout(() => {
          this.editInternalDetailsTxtMsg = '';
          this.editInternalDetailsIsOpen = false;
        }, 5000);
      });
  }
}

export default ViewController;



// WEBPACK FOOTER //
// ./client/app/cases/view/view.controller.js